import $ from "jquery";

const home = '-home',
      header = $('#js-header'),
      nav = $('#js-nav'),
      open = $('#js-open');

$(window).on('scroll', function() {
  if ($(window).scrollTop() > 100) {
    header.removeClass(home);
    nav.removeClass(home);
    open.removeClass(home);
  } else {
    if($('body#js-home').length) {
      header.addClass(home);
      nav.addClass(home);
      open.addClass(home);
    }
  }
});

$('.js-navReverse').hover(
  (event) => {
    header.removeClass(home);
    nav.removeClass(home);
    open.removeClass(home);
  },
  (event) => {
    if($(window).scrollTop() < 100 && $('body#js-home').length) {
      header.addClass(home);
      nav.addClass(home);
      open.addClass(home);
    }
  }
)
